import BaseHandler from "../BaseHandler";
import { ChannelAvatarAdd, ChannelAvatarAddResponse } from "../../proto/ChannelAvatarAdd_pb";
import { ChannelAvatarDelete, ChannelAvatarDeleteResponse } from "../../proto/ChannelAvatarDelete_pb";
import store from "../../store";
import { editRoom, editRoomExtra } from "../../store/rooms/actions";
import { removeAvatar } from "../../store/avatars/actions";
import { last } from "lodash";

export default class HandleChannelAvatarDeleteResponse extends BaseHandler<ChannelAvatarDeleteResponse, ChannelAvatarDelete> {
  handle() {
    const channelAvatarDeleteResponseLink = this.response.toObject();
    if (channelAvatarDeleteResponseLink !== undefined) {
      store.dispatch(removeAvatar({ roomId: channelAvatarDeleteResponseLink.roomId, avatarId: channelAvatarDeleteResponseLink.id }));
      const room = store.getState().rooms.rooms[channelAvatarDeleteResponseLink.roomId];
      const lastAvatarId = last(store.getState().avatars.roomAvatars[channelAvatarDeleteResponseLink.roomId]);
      const newAvatar = lastAvatarId ? store.getState().avatars.avatars[lastAvatarId] : undefined;
      if (room.channelRoomExtra) {
        store.dispatch(
          editRoom({
            room: {
              ...room,
              channelRoomExtra: {
                ...room.channelRoomExtra,
                avatar: newAvatar,
              },
            },
            roomId: channelAvatarDeleteResponseLink.roomId,
          })
        );
      }
    }
  }
}
